/**
 * Custom Recharts tooltip used by Reports revenue/orders charts.
 *
 * Extracted from Reports.tsx during the Maintainability Sprint 2026-04-19
 * (Task 1.2). Behavior and French copy preserved byte-for-byte.
 */

import { formatFcfa } from "./formatters";

export interface ChartTooltipProps {
  readonly active?: boolean;
  readonly payload?: readonly {
    value: number;
    name: string;
    color: string;
  }[];
  readonly label?: string;
}

export default function ChartTooltip({
  active,
  payload,
  label,
}: ChartTooltipProps) {
  if (!active || !payload || payload.length === 0) return null;
  return (
    <div className="rounded-lg border border-stone-200 bg-white px-3 py-2 shadow-md">
      <p className="text-xs font-medium text-stone-500">{label}</p>
      {payload.map((entry) => (
        <p
          key={entry.name}
          className="text-sm font-semibold"
          style={{ color: entry.color }}
        >
          {entry.name === "revenue_fcfa" ? "Revenu" : "Commandes"} :{" "}
          {entry.name === "revenue_fcfa"
            ? formatFcfa(entry.value)
            : entry.value}
        </p>
      ))}
    </div>
  );
}
